module.exports = __webpack_public_path__ + "img/consecuencia1.aa8ac2f9.png";